<template>
  <div class="comp-alert-paper-analysis pt20">
    <div class="analysis-charts flex-between">
      <div class="chart-type">
        <div class="tc fwb">按题型统计（总题数：<span class="text-primary">{{data.typeChartData.testNum || '--'}}题</span>）</div>
        <div class="chart" ref="chartType"></div>
      </div>
      <div class="chart-diff">
        <div class="tc fwb">按难易统计（总体难度：<span class="text-primary">{{data.diffChartData.avgDiff || '--'}}</span>）</div>
        <div class="chart" ref="chartDiff"></div>
      </div>
    </div>
    <div class="tc fwb mb15">知识点统计（考核知识点：<span class="text-primary">{{data.klTableData.klDataLength || '--'}}个</span>）</div>
    <table class="table table-bordered pct100">
      <tr align="center">
        <th width="80">题号</th>
        <th width="160">题型</th>
        <th width="80">难度</th>
        <th>知识点</th>
      </tr>
      <tr align="center" v-for="(item, index) in data.klTableData.tableData" :key="index">
        <td>{{item.queNum}}</td>
        <td>{{item.typesName}}</td>
        <td>{{item.diffName}}</td>
        <td class="kl-list" align="left">
          <template v-if="item.klList && item.klList.length"><div v-for="(item1, index1) in item.klList" :key="index1 + 100"> {{item1}}</div></template>
          <template v-else>--</template>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/12
   * @project zujuanzaixian
   * @desc
   */
  import {mapGetters} from 'vuex'
  export default {
    name: 'comp-alert-paper-analysis',
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        chartType: '',
        chartDiff: ''
      }
    },
    computed: {
      ...mapGetters(['deviceWidth'])
    },
    watch: {
      deviceWidth () {
        this.chartType.resize()
        this.chartDiff.resize()
      },
      data: {
        handler (v) {
          this.$nextTick(() => {
            this.initChart()
          })
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      initChart () {
        let option1 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}'
          },
          color: ['#9FE6B8', '#32C5E9', '#FB7293', '#FF9F7F', '#8378EA'],
          series: [
            {
              name: '题型统计：',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: this.data.typeChartData.seriesData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        this.chartType = this.$echarts.init(this.$refs.chartType)
        this.chartType.setOption(option1)
        let option2 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}'
          },
          color: ['#9FE6B8', '#32C5E9', '#FB7293', '#FF9F7F', '#8378EA'],
          series: [
            {
              name: '难易统计：',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: this.data.diffChartData.seriesData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        this.chartDiff = this.$echarts.init(this.$refs.chartDiff)
        this.chartDiff.setOption(option2)
      }
    }
  }
</script>

<style lang="less">
  @import "../../styles/_mixins-wln";
  .comp-alert-paper-analysis {
    overflow-y: auto;
    .analysis-charts{
      margin:0 15px;
      .chart{
        height: 250px;
        width: 380px;
      }
    }
    table{
      th{
        background: @bg-body;
        font-weight: bold;
      }
      td{
        font-size: 13px;
        &.kl-list{
          padding: 0.8em;
          line-height: 1.7;
        }
      }
    }
  }
</style>
